/**
 * @see https://mewtant-inc.sg.larksuite.com/wiki/Wqzsw2khoim79Gko5z5lzFmngKc
 */
export const MioExpression = {
  Happy: 'happy',
  Sulk: 'sulk',
  Question: 'question',
  Idea: 'idea',
  Cry: 'cry',
  Respect: 'respect',
  Great: 'great',
  Pokke: 'pokke',
} as const
export type MioExpressionType =
  (typeof MioExpression)[keyof typeof MioExpression]

export type MioVariant = 'light' | 'dark'

export function isValidMioImageUrl(str?: string): str is string {
  if (!str) return false
  try {
    const { protocol } = new URL(str)
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}

// Copied from src/i18n/en/common.json → resources.chibi.
// Used as fallback when i18n is uninitialised and t() returns the raw key.
export const CHIBI_FALLBACK: Record<
  MioExpressionType,
  Record<MioVariant, string>
> = {
  cry: {
    light:
      'https://images-ng.pixai.art/images/orig/854c6cec-4c58-4c03-a419-9e88a90a1305',
    dark: 'https://images-ng.pixai.art/images/orig/9f26d836-b1c9-486d-8db6-7d6a2bbe64bf',
  },
  happy: {
    light:
      'https://images-ng.pixai.art/images/orig/3eae9043-ec07-4e2a-b422-0a13f2be6611',
    dark: 'https://images-ng.pixai.art/images/orig/21c2bbd3-bb53-4842-978e-4b254ed9aa6e',
  },
  sulk: {
    light:
      'https://images-ng.pixai.art/images/orig/21585d7a-97ab-4c28-91ac-8ac6c2257636',
    dark: 'https://images-ng.pixai.art/images/orig/0a3b9eb7-9116-44c1-95ea-91ac23ea5fd3',
  },
  question: {
    light:
      'https://images-ng.pixai.art/images/orig/19b4cb66-81e0-4f6b-899a-48b6ae799ac6',
    dark: 'https://images-ng.pixai.art/images/orig/60d8e16d-cd75-40eb-b2bd-725dac09e35d',
  },
  idea: {
    light:
      'https://images-ng.pixai.art/images/orig/37bc9759-a46c-49f0-bbe1-091815b6e7bf',
    dark: 'https://images-ng.pixai.art/images/orig/86c76ca9-6ca7-4db3-a939-88f370d2b0c3',
  },
  respect: {
    light:
      'https://images-ng.pixai.art/images/orig/fded2a15-55c6-4ed1-ac96-ab9294b76412',
    dark: 'https://images-ng.pixai.art/images/orig/29343ea1-9086-4010-98c6-f6c52f942cdc',
  },
  great: {
    light:
      'https://images-ng.pixai.art/images/orig/3d706a61-f583-4b75-9a83-0743b8f93b12',
    dark: 'https://images-ng.pixai.art/images/orig/69373668-6fa0-44b9-ad7b-d5f35bbae17c',
  },
  pokke: {
    light:
      'https://images-ng.pixai.art/images/orig/3892e3b5-f877-4964-b578-4d76d0045998',
    dark: 'https://images-ng.pixai.art/images/orig/4129638b-f1fe-4d2a-b63d-262bb2e63be6',
  },
}
